/// <reference path="../_references.ts"/>

module App.Helpers {
	interface Scope extends ng.IScope {
		ngModel?: string
	}

	export class SignatureArea implements ng.IDirective {
		public static Factory() {
            return [
            	'$window',
            	($window: ng.IWindowService) => new SignatureArea($window)
            ];
		}

		public template = '<canvas></canvas>';
		public replace = true;
		public restrict = 'E';
		public scope = {
			ngModel: '='
		};

		constructor(
			protected $window: ng.IWindowService
		) { }

		protected resizeCanvas(canvas: HTMLCanvasElement, signaturePad: SignaturePad): void {
			const sig = signaturePad.toDataURL(),
				  ratio =  Math.max(this.$window.devicePixelRatio || 1, 1);

			canvas.width = canvas.offsetWidth * ratio;
			canvas.height = canvas.offsetHeight * ratio;
			canvas.getContext('2d').scale(ratio, ratio);

			signaturePad.fromDataURL(sig);
		}

		public link($scope: Scope, elem: ng.IAugmentedJQuery): void {
			let canvas = <HTMLCanvasElement>elem[0],
				signaturePad = new SignaturePad(canvas),
				resizeFn = this.resizeCanvas.bind(this, canvas, signaturePad);

			$scope.$watch(
				() => $scope.ngModel,
				(value?: string) => {
					if (!value || value === '') {
						signaturePad.clear();
					} else {
						signaturePad.fromDataURL(value);
					}
				}
			);

			elem.addClass('signature-form');

			signaturePad.onEnd = () => {
				$scope.ngModel = signaturePad.toDataURL();
				$scope.$apply()
			};

			angular.element(this.$window).bind('resize', () => {
				resizeFn();
			});

			resizeFn();

			try {
				signaturePad.fromDataURL($scope.ngModel);
			} catch (ex) { /* Ignore */ }
		}
	}
	angular
		.module('helpers.signature', [])
		.directive('signatureArea', SignatureArea.Factory());
}
